
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';
import { useToast } from '@/components/ui/use-toast';
import { Link } from 'react-router-dom';

const ContactForm = () => {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    privacyConsent: false
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.privacyConsent) {
      toast({
        title: "נדרשת הסכמה",
        description: "עליך לאשר את מדיניות הפרטיות ותנאי השימוש כדי להמשיך.",
        variant: "destructive"
      });
      return;
    }
    
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      toast({
        title: "הטופס נשלח בהצלחה",
        description: "תודה על פנייתך. ניצור איתך קשר בהקדם.",
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        privacyConsent: false
      });
      setIsSubmitting(false);
    }, 1500);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <label htmlFor="name" className="text-sm font-medium">
            שם מלא *
          </label>
          <Input
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="bg-gray-100 border-0"
          />
        </div>
        
        <div className="space-y-2">
          <label htmlFor="email" className="text-sm font-medium">
            אימייל *
          </label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="bg-gray-100 border-0"
          />
        </div>
        
        <div className="space-y-2">
          <label htmlFor="phone" className="text-sm font-medium">
            טלפון
          </label>
          <Input
            id="phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            className="bg-gray-100 border-0"
          />
        </div>
        
        <div className="space-y-2">
          <label htmlFor="subject" className="text-sm font-medium">
            נושא *
          </label>
          <Input
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
            className="bg-gray-100 border-0"
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <label htmlFor="message" className="text-sm font-medium">
          הודעה *
        </label>
        <Textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          className="bg-gray-100 border-0 min-h-[150px]"
        />
      </div>
      
      <div className="flex items-start gap-3">
        <Checkbox
          id="privacyConsent"
          checked={formData.privacyConsent}
          onCheckedChange={(checked) => 
            setFormData(prev => ({ ...prev, privacyConsent: checked as boolean }))
          }
          className="mt-1 shrink-0"
        />
        <label htmlFor="privacyConsent" className="text-xs sm:text-sm text-muted-foreground cursor-pointer leading-relaxed">
          אני מאשר/ת כי קראתי והבנתי את{' '}
          <Link to="/privacy" className="text-primary hover:underline">
            מדיניות הפרטיות
          </Link>
          {' '}ו
          <Link to="/terms" className="text-primary hover:underline">
            תנאי השימוש
          </Link>
          , ומסכים/ה לתנאים המפורטים בהם. *
        </label>
      </div>
      
      <Button 
        type="submit" 
        disabled={isSubmitting}
        className="bg-black text-white hover:bg-gray-800 px-8 py-2 h-auto"
      >
        {isSubmitting ? 'שולח...' : 'שלח'}
      </Button>
    </form>
  );
};

export default ContactForm;
